import { Controller } from 'stimulus';

export default class extends Controller {
  connect(){
    this.element.addEventListener('click', this.performRequest.bind(this));
  }


  performRequest(input){
    window.KTApp.blockPage(this.element, {});
    window.Ajax.get(input.currentTarget.dataset.url, this.ajaxOptions());
  }

  handleSuccess(response){
    const doc_check = document.querySelector(".is-checked")
    if (doc_check){
      doc_check.classList.remove("is-checked");
      const hiddenPem = document.querySelector("#hpem")
      hiddenPem.click();
    }
    
    let tmp = document.createElement("div");
    tmp.innerHTML = response
    const xtml = document.querySelector("#membership_and_payment")
    xtml.innerHTML = tmp.innerHTML
  }

  handleFail(response){
    console.log(response)
    Flash.show("danger", "Data Tidak Ditemukan")
    const xtml = document.querySelector("#membership_and_payment")
    xtml.parentElement.querySelectorAll('input')[0].click();
  }

  handleDone(){
    window.KTApp.unblockPage();
  }

  ajaxOptions(dataPost){
    return {
      headers: [
        {
          key: 'X-CSRF-Token',
          value: window.Util.getCsrfToken()
        },
        {
          key: 'Content-Type',
          value: 'application/json'
        }
      ],
      onSuccess: this.handleSuccess.bind(this),
      onFail: this.handleFail.bind(this),
      onDone: this.handleDone.bind(this)
    }
  }
}